import React from "react";
import SavingsCard from "./SavingsCard";
import timerIcon from "./../../../assets/sand_timer.svg";
import savingBoxIcon from "./../../../assets/savings_box.svg";

function Savings({ props, costGoingPaperLess, isUsingDigitalIntakePlatform }) {
  const { monthlyTimeSavingInHours, annualCostSavings } = props;
  const totalStaffSavings = isUsingDigitalIntakePlatform ? costGoingPaperLess.annualCostSavings : 0;
  const divStyle = {
    background: "linear-gradient(to bottom, #a4f07e, #ffffff)",
  };

  return (
    <div className="h-[150px] w-full mt-4 py-1 text-custom-margin">
      <p className="text-xl font-bold mb-4">
        By digitizing intake workflows with CheckinAsyst, you save:
      </p>
      <div className="flex gap-5 mt-2" id="saving-card">
        <SavingsCard
          type="HOURS"
          icon={timerIcon}
          width={30}
          title="hours per month for your staff"
          value={monthlyTimeSavingInHours}
          color={"#71B254"}
        />
        <SavingsCard
          type="COST"
          icon={savingBoxIcon}
          width={40}
          title="annually"
          value={annualCostSavings + totalStaffSavings}
          color={"#147D6E"}
        />
      </div>
    </div>
  );
}

export default Savings;
